module.exports = __webpack_public_path__ + "img/concept-icon.f12160b7.svg";